import { render, staticRenderFns } from "./ChatRobotIcon.vue?vue&type=template&id=706c6092&scoped=true"
import script from "./ChatRobotIcon.vue?vue&type=script&lang=js"
export * from "./ChatRobotIcon.vue?vue&type=script&lang=js"
import style0 from "./ChatRobotIcon.vue?vue&type=style&index=0&id=706c6092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c6092",
  null
  
)

export default component.exports